import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { 
  fetchAttendanceRuleRequest, 
  createAttendanceRuleRequest, 
  editAttendanceRuleRequest 
} from "../../../api/attendanceRule";
import { 
  attendanceRuleTypeSelectOptions,
  attendanceRuleCalculationTypeSelectOptions,
  attendanceRuleCalculationTypeTwoSelectOptions
} from "../../../variables/Variables.jsx";

class AttendanceRuleForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        type: '',
        calculationType: '',
        label: '',
        description: '',
        standard: {},
        monday: {},
        tuesday: {},
        wednesday: {},
        thursday: {},
        friday: {},
        saturday: {},
        sunday: {},
        overtimeConfig: {},
        nightShiftConfig: {}
      },
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchAttendanceRuleRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      type,
      calculationType,
      label,
      description,
      standard,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      nightShiftConfig,
      overtimeConfig
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      type,
      calculationType,
      label,
      description,
      standard,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      nightShiftConfig,
      overtimeConfig
    };

    if (isNewRecord) {
        createAttendanceRuleRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editAttendanceRuleRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('attendance-rule');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message ||'There was an error saving Attendance Rule.' })
  }

  handleScheduleChange = (e, day) => {

    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [day]: {
          ...prevState.resource[day],
          [name]: value,
        },
      }
    }))
  }

  handleNSDConfigChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        ['nightShiftConfig']: {
          ...prevState.resource['nightShiftConfig'],
          [name]: value,
        },
      }
    }))
  }

  handleOTConfigChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        ['overtimeConfig']: {
          ...prevState.resource['overtimeConfig'],
          [name]: value,
        },
      }
    }))
  }

  render() {

    const {
      type,
      calculationType,
      label,
      description,
      standard,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      nightShiftConfig,
      overtimeConfig
    } = this.state.resource;

    const {
      error
    } = this.state;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('attendance-rule')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Type <span className="required-star">*</span></ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="type"
                      value={type}
                    >
                    <option value="">Select</option>
                    {attendanceRuleTypeSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                          title={option.description}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Rule Name</ControlLabel>
                  <FormControl
                    type="text"
                    name="label"
                    value={label}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Description</ControlLabel>
                  <FormControl
                    type="text"
                    name="description"
                    value={description}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Calculation Type <span className="required-star">*</span></ControlLabel>
                    <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="calculationType"
                      value={calculationType}
                    >
                    <option value="">Select</option>
                    {type && ["late", "absent", "undertime"].includes(type) &&
                      attendanceRuleCalculationTypeSelectOptions.map(option => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                            title={option.description}
                          >
                            {option.label}
                          </option>
                        );
                      })
                    }
                    {type && ["overtime", "nightShift"].includes(type) &&
                      attendanceRuleCalculationTypeTwoSelectOptions.map(option => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                            title={option.description}
                          >
                            {option.label}
                          </option>
                        );
                      })
                    }
                  </FormControl>
                </FormGroup>
                {calculationType === "noDeduction" &&
                  <Alert bsStyle="info">
                    No deduction will be applied regardless of attendance entries
                  </Alert>
                }
                {calculationType === "deductPerMinute" &&
                  <Alert bsStyle="info">
                    Deduction will be applied according to 1) attendance entries and 2) employee wage*
                    <br />
                    * The employee wage will be used to calculate the proportional period wage
                  </Alert>
                }
                {calculationType === "multiplicator" &&
                  <Alert bsStyle="info">
                    Deduction will be applied according to 1) attendance entries, 2) employee wage* and 
                    3) a multiplicator**
                    <br />
                    * The employee wage will be used to calculate the proportional period wage
                    <br /> 
                    ** The multiplicator will multiply the proportinal period wage. At least the standard 
                    values must be specified (each day of the week can be optionally specified)
                  </Alert>
                }
                {calculationType === "noAddition" &&
                  <Alert bsStyle="info">
                    No addition will be applied regardless of attendance entries
                  </Alert>
                }
                {calculationType === "addPerMinute" &&
                  <Alert bsStyle="info">
                    Addition will be applied according to 1) attendance entries, 2) employee wage* and
                    3) a multiplicator**
                    <br />
                    * The employee wage will be used to calculate the proportional period wage
                    ** The multiplicator will multiply the proportinal period wage
                  </Alert>
                }
                {calculationType === "addPerMinute" && type === "nightShift" &&
                  <div className="form-section-wrapper">
                    <h3 className="title">Parameters <span className="required-star">*</span></h3>
                    <label 
                      className="form-helper-text"
                      style={{
                        marginBottom: "15px"
                      }}
                    >
                      Input the night differential pay multiplier using decimal points. For example, for 100% use 1.00
                      <br/>
                      Input the start and end times for the Night Shift in 24 hour format without seconds (eg: 23:00)
                      <br/>
                      If present, start and end times will be used to calculate the valid duration of the Night Shift.
                    </label>
                    <FormGroup>
                      <ControlLabel>Percentage</ControlLabel>
                      <FormControl
                        type="text"
                        name="percentage"
                        value={nightShiftConfig.percentage}
                        onChange={this.handleNSDConfigChange }
                        placeholder=""
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Start Time</ControlLabel>
                      <FormControl
                        type="text"
                        name="startTime"
                        value={nightShiftConfig.startTime}
                        onChange={this.handleNSDConfigChange }
                        placeholder=""
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>End Time</ControlLabel>
                      <FormControl
                        type="text"
                        name="endTime"
                        value={nightShiftConfig.endTime}
                        onChange={this.handleNSDConfigChange }
                        placeholder=""
                      />
                    </FormGroup>
                  </div>
                }
                {calculationType === "addPerMinute" && type === "overtime" &&
                  <div className="form-section-wrapper">
                    <h3 className="title">Parameters <span className="required-star">*</span></h3>
                    <label 
                      className="form-helper-text"
                      style={{
                        marginBottom: "15px"
                      }}
                    >
                      Input the overtime pay multiplier using decimal points. For example, for 125% use 1.25
                    </label>
                    <FormGroup>
                      <ControlLabel>Percentage</ControlLabel>
                      <FormControl
                        type="text"
                        name="percentage"
                        value={overtimeConfig.percentage}
                        onChange={this.handleOTConfigChange}
                        placeholder=""
                      />
                    </FormGroup>
                  </div>
                }
                {calculationType === "multiplicator" &&
                  <div className="form-section-wrapper">
                    <h3 className="title">Multiplicator <span className="required-star">*</span></h3>
                    <label 
                      className="form-helper-text"
                      style={{
                        marginBottom: "15px"
                      }}
                    >
                      Use dots as decimal points (eg: 1.125). Only provide values for periods that differ from the standard
                    </label>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Standard <span className="required-star">*</span>
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={standard.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'standard')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={standard.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'standard')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={standard.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'standard')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Monday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={monday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'monday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={monday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'monday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={monday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'monday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Tuesday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={tuesday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'tuesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={tuesday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'tuesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={tuesday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'tuesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Wednesday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={wednesday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'wednesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={wednesday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'wednesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={wednesday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'wednesday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Thursday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={thursday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'thursday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={thursday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'thursday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={thursday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'thursday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Friday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={friday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'friday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={friday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'friday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={friday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'friday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Saturday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={saturday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'saturday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={saturday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'saturday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={saturday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'saturday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                    <Row
                      className="form-section"
                    >
                        <div className="col-md-12">
                          <h6>
                            Sunday
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Whole Day</ControlLabel>
                            <FormControl
                              type="text"
                              name="wholeDay"
                              value={sunday.wholeDay}
                              onChange={(e) => this.handleScheduleChange(e, 'sunday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day AM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayAm"
                              value={sunday.halfDayAm}
                              onChange={(e) => this.handleScheduleChange(e, 'sunday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Half Day PM</ControlLabel>
                            <FormControl
                              type="text"
                              name="halfDayPm"
                              value={sunday.halfDayPm}
                              onChange={(e) => this.handleScheduleChange(e, 'sunday')}
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                    </Row>
                  </div>
                }

                {error &&
                  <Alert bsStyle="danger">
                      {error}
                  </Alert>
                }

                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default AttendanceRuleForm;
